import { render, staticRenderFns } from "./PdfViewerContainer.vue?vue&type=template&id=04f1cfca"
import script from "./PdfViewerContainer.vue?vue&type=script&lang=ts"
export * from "./PdfViewerContainer.vue?vue&type=script&lang=ts"
import style0 from "./PdfViewerContainer.vue?vue&type=style&index=0&id=04f1cfca&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports